import { render, staticRenderFns } from "./IndexComponent.vue?vue&type=template&id=d6807da2"
import script from "./IndexComponent.vue?vue&type=script&lang=js"
export * from "./IndexComponent.vue?vue&type=script&lang=js"
import style0 from "./IndexComponent.vue?vue&type=style&index=0&id=d6807da2&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports